import React, { useState, useEffect } from "react";
import Serviceclasses from "../ServicePage/Service.module.css";
import { gethomeserviceCategory } from "../../../Services/APIrequests"; // Using the updated API request
import { BsFillBuildingsFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import defaultIMG from "../../../Assets/defaultimg.png";

const Servicess = ({ service }) => {
  const navigate = useNavigate();
  const { category, description, thumbnailUrl, id } = service; // Updated to reflect the new response structure
  const defaultImage = "https://via.placeholder.com/150";

  const handleClick = (id, category) => {
    const formattedCategory = category.replace(/\s+/g, "_");
    navigate(`/services/${formattedCategory}`);
  };

  return (
    <div
      className={Serviceclasses.Servicecard}
      onClick={() => handleClick(id, category)}
    >
      <div className={Serviceclasses.ServicecardImage}>
        <img
          src={thumbnailUrl || defaultImage}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultIMG;
          }}
          alt={category} // Using category name for alt text
        />
      </div>
      <div className={Serviceclasses.Servicecard2}>
        

       <div className={Serviceclasses.ServicecardContent}>
        <div className={Serviceclasses.ServicecardFooter}>
          <h2 className={Serviceclasses.ServicecardTitle}>{category}</h2>{" "}
          {/* Using category name */}
          <div className={Serviceclasses.ServiceIcon}>
            <BsFillBuildingsFill />
          </div>
        </div>

        <div className={Serviceclasses.ServicecardContent}>
          <p className={Serviceclasses.Servicecsmallarddescr}>
            {description || "Description not available"}{" "}
            {/* Display category description */}
          </p>
        </div>
</div>
        <div className={Serviceclasses.Servicecard_readmore}>
          <div
            onClick={() => handleClick(id, category)}
            className={Serviceclasses.ServicecardLink}
          >
            View All Services
          </div>
        </div>
      </div>
    </div>
  );
};

const Serviceclassess = () => {
  const [services, setServices] = useState([]);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await gethomeserviceCategory(); // Fetch categories from the API
        if (response.data && Array.isArray(response.data.categories)) {
          const sortedServices = response.data.categories.sort(
            (a, b) => a.priority - b.priority
          );
          setServices(sortedServices); // Set sorted services
        } else {
          console.error("Unexpected response structure:", response);
          setServices([]);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  return (
    <div className={Serviceclasses.Servicecontainer}>
      <h1>
        Explore Our <span>Services</span>
      </h1>
      <div className={Serviceclasses.ServicecardGrid}>
        {services.length > 0 &&
          services.map((service) => (
            <Servicess key={service.id} service={service} />
          ))}
      </div>

      {/* Show message outside the grid if no services are available */}
      {services.length === 0 && (
        <p
          style={{ textAlign: "center", marginTop: "20px", fontWeight: "500" }}
        >
          No services available at the moment.
        </p>
      )}
    </div>
  );
};

export default Serviceclassess;
